export default __webpack_public_path__ + "static/media/igloo_thumb.26c6faae.jpg";